import { _Web } from "../webs/types.js";
import { SiteScripts } from "./types.js";
_Web.prototype.getSiteScript = function (extractInfo) {
    return SiteScripts(this.toUrl(), "").getSiteScriptFromWeb(undefined, extractInfo);
};
//# sourceMappingURL=web.js.map